export default __webpack_public_path__ + "static/media/3.9273499f.jpg";